// One deferred connect per app runtime. No component owns this slot; the request
// records its owner, and every settle path runs through that owner's options.
let pending = null;
const inFlight = new Set();
const listeners = new Set();
let version = 0;
export function notify() {
    version += 1;
    listeners.forEach((listener) => {
        listener();
    });
}
export function subscribe(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
export function getVersion() {
    return version;
}
export function getPending() {
    return pending;
}
export function setPending(next) {
    pending = next;
    notify();
}
export function isInFlight(userId) {
    return inFlight.has(userId);
}
export function markInFlight(userId) {
    inFlight.add(userId);
    notify();
}
export function clearInFlight(userId) {
    inFlight.delete(userId);
    notify();
}
export function isConnecting(userId) {
    return pending?.target.userId === userId || inFlight.has(userId);
}
export function reset() {
    pending = null;
    inFlight.clear();
    notify();
}
//# sourceMappingURL=slot.js.map